import Camera from "react-html5-camera-photo";
const CameraComponent = Camera as unknown as React.FC<any>;
export default CameraComponent;
